import { useBooking, useOrder } from '../state';

import shallow from 'zustand/shallow';
import { useOfferHandler } from './use-offer-handler';
import { yourTicketPageRegExp, moviePageRegExp } from '@/constants/regular-expressions';

export const useClearBooking = () => {
  const [booking, setBooking, setIsLegalBookingFlow] = useBooking(
    s => [s.booking, s.setBooking, s.setIsLegalBookingFlow],
    shallow
  );
  const [setOrder, setGuestBookingInfo, setStcPayData] = useOrder(
    s => [s.setOrder, s.setGuestBookingInfo, s.setStcPayData],
    shallow
  );
  const { handleDeleteOffer } = useOfferHandler(booking?.offer);

  const clearBooking = (nextPath: string = null) => {
    if (nextPath) {
      setBooking(null);
      setIsLegalBookingFlow(false);
      if (!yourTicketPageRegExp.test(nextPath)) {
        setOrder(null);
        setStcPayData(null);
      }
      setGuestBookingInfo(null);
      if (!moviePageRegExp.test(nextPath)) {
        handleDeleteOffer();
      }
    } else {
      setBooking(null);
      setIsLegalBookingFlow(false);
      setOrder(null);
      setStcPayData(null);
      setGuestBookingInfo(null);
    }
  };

  return {
    clearBooking,
  };
};
